import React from 'react'
import ImageText from '~/components/slices/imageText'
import AccordionList from '~/components/slices/accordionList'
import Tabs from '~/components/slices/tabs'
import Actions from '~/components/slices/actionsGroup'
import SimulatorFuel from '~/components/slices/simulatorFuel/SimulatorFuel'
import TextFull from '~/components/slices/textFull'
import VideoPlayer from '~/components/slices/videoPlayer'
import Testimony from '~/components/slices/testimony'
import SliderMedias from '~/components/slices/sliderMedias'
import SliderKeyFigures from '~/components/slices/sliderKeyFigures'
import SliderPartners from '~/components/slices/sliderPartners'
import ImageTextSet from '~/components/slices/imageTextSet'
import ImageSlice from '~/components/slices/imageSlice'
import ImageTextProfile from '~/components/slices/imageTextProfile'
import Flipbook from '~/components/slices/flipbook'
import Iframe from '~/components/slices/iframe'
import Faq from '~/components/features/contact/faq'
import slugify from 'slugify'

const SlicesWrapper = ({
  slices,
  isProject = false,
  isMediaLibrary = false,
  profile = null,
  currentContact = null,
}) => {
  // render slices components based on content type
  const renderSlice = (slice, type) => {
    switch (type) {
      case 'ContentfulFullText':
        return (
          <>
            {!isMediaLibrary && <TextFull data={slice} isProject={isProject} />}
          </>
        )
      case 'ContentfulSliceGroupeDaction':
        return (
          <>
            {!isMediaLibrary && <Actions data={slice} isProject={isProject} />}
          </>
        )
      case 'ContentfulSliceSimulateurCarburant':
        return <>{!isMediaLibrary && <SimulatorFuel data={slice} />}</>
      case 'ContentfulSlicePdf':
        return <>{!isMediaLibrary && <Flipbook data={slice} />}</>
      case 'ContentfulVideo':
        return (
          <>
            {!isMediaLibrary && (
              <VideoPlayer
                data={slice}
                isProject={isProject}
                profile={profile}
              />
            )}
          </>
        )
      case 'ContentfulImageTexteSection':
        return (
          <>
            {!isMediaLibrary && (
              <>
                {profile ? (
                  <ImageTextProfile data={slice} />
                ) : (
                  <ImageText data={slice} isProject={isProject} />
                )}
              </>
            )}
          </>
        )
      case 'ContentfulTestimony':
        return (
          <>
            {!isMediaLibrary && (
              <Testimony
                data={slice}
                isProject={isProject}
                isBiger={profile !== null}
              />
            )}
          </>
        )
      case 'ContentfulSliderPartnersClients':
        return (
          <>
            {!isMediaLibrary && (
              <SliderPartners data={slice} isProject={isProject} />
            )}
          </>
        )
      case 'ContentfulSlider':
        return (
          <>
            {slice.type === 'Medias' ? (
              <SliderMedias
                // key={JSON.stringify(slice.items.map((item) => item.id))}
                data={slice}
                isProject={isProject}
                isMediaLibrary={isMediaLibrary}
              />
            ) : (
              <>
                {!isMediaLibrary && (
                  <SliderKeyFigures data={slice} isProject={isProject} />
                )}
              </>
            )}
          </>
        )
      case 'ContentfulSliceImage':
        return (
          <>
            {!isMediaLibrary && (
              <ImageSlice data={slice} isProject={isProject} />
            )}
          </>
        )
      case 'ContentfulTabsaccordion':
        return (
          <>
            {!isMediaLibrary && (
              <>
                {slice.type === 'Accordion' ? (
                  <AccordionList data={slice} isProject={isProject} />
                ) : (
                  <Tabs data={slice} isProject={isProject} />
                )}
              </>
            )}
          </>
        )
      case 'ContentfulIframe':
        return <>{!isMediaLibrary && <Iframe data={slice} />}</>
      case 'ContentfulFaqSet':
        return (
          <div className="col-12 lg-col-10 xl-col-8 mx-auto">
            <Faq
              data={slice}
              profile={profile}
              currentContact={currentContact}
            />
          </div>
        )
      case 'ContentfulImageTextSet':
        return <ImageTextSet data={slice} />
      default:
        return 'error'
    }
  }

  const previewContentType = (type) => {
    return `Contentful${type.charAt(0).toUpperCase() + type.slice(1)}`
  }

  return (
    <>
      {slices &&
        slices.map((item, i) => {
          let slice = item.fields ? item.fields : item
          let type = item.fields
            ? previewContentType(item.sys.contentType.sys.id)
            : item.internal?.type
          let subtype = false
          let typesBgs = [
            'ContentfulImageTexteSection',
            'ContentfulTabsaccordion',
            'ContentfulTestimony',
            'ContentfulSlicePdf',
            'ContentfulSliceGroupeDaction',
            'ContentfulSliceSimulateurCarburant',
          ]

          if (isProject) {
            typesBgs.push('ContentfulSlider')

            if (type === 'ContentfulSlider' && slice.type !== 'Key figures') {
              subtype = true
            }
          }

          if (profile) {
            typesBgs.splice(0, 1)
          }

          if (type === 'ContentfulTabsaccordion') {
            if (slice.type === 'Accordion') {
              subtype = true
            }
          }

          return (
            <section
              id={
                slice.title
                  ? slugify(slice.title)
                  : slice.titleContent
                    ? slugify(slice.titleContent)
                    : ''
              }
              data-name={slice.title ? slice.title : ''}
              className={`${isProject ? 'anchor-slice' : ''} slice ${profile ? 'slice--profile' : ''} ${typesBgs.indexOf(type) !== -1 && !subtype ? 'slice--bg' : ''}`}
              key={i}
            >
              {renderSlice(slice, type)}
            </section>
          )
        })}
    </>
  )
}

export default SlicesWrapper
